module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/2758236017656df6797520e87cfd76f1.png";